module.exports = __webpack_public_path__ + "assets/img/dislike-active.b2b25530.svg";